import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import AAF from "src/AAF/AAF";

class LevelTask extends AbstractRequestTask {

    constructor(node = "", user_status = '', version = 'v2' ) {
        super();
        this._node = node;
        this._user_status = user_status;
        this._version = version;
        this.module_version = 'v4';
    }

    getHeaders() {
        return {};
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/cms/v2/level`;
    }

    getParams() {
        const params = super.getParams();
        
        const node = this._node;
        const user_status = this._user_status;
        delete params.api_version;
        delete params.HKS;
        const type = AAF.AdsUtils.getUserType();
        if (type) params.type = type;
        params.module_version = this.module_version;

        return Object.assign({}, params, { node, user_status });
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
      return ENABLE_MODAL_RETRIES;
    }
}

export default LevelTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/LevelTask.js